var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuMoreHelpTutorials = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20.32 20.32",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.16,
    cy: 10.16,
    r: 9.13,
    style: {
      fill: "none",
      strokeMiterlimit: 10.00000017133541,
      strokeWidth: "2.0599999780746345px"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.48,8.64c.38-.27.72-.51.72-.88s-.29-.71-1-.71a2,2,0,0,0-1.52.77l-1-1.13a3.54,3.54,0,0,1,2.71-1.2c1.6,0,2.58.8,2.58,2a2.29,2.29,0,0,1-1.25,1.93c-.43.32-.82.59-.82,1a.76.76,0,0,0,.22.52l-1.35.4a1.6,1.6,0,0,1-.41-1.09A2,2,0,0,1,10.48,8.64ZM10.39,12a1,1,0,1,1-1,1A1,1,0,0,1,10.39,12Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuMoreHelpTutorials, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu_More_Help_Tutorials.43f95c08.svg";
export { ForwardRef as ReactComponent };